import { useState, useEffect } from "react";
import { Download, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PWABanner() {
  const [prompt, setPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem("ah_visit_counted")) {
      sessionStorage.setItem("ah_visit_counted", "1");
      localStorage.setItem("ah_visits", String(Number(localStorage.getItem("ah_visits") || 0) + 1));
    }
    if (localStorage.getItem("aether_pwa_dismissed") || Number(localStorage.getItem("ah_visits")) < 2) return;
    const handler = (e) => { e.preventDefault(); setPrompt(e); setVisible(true); };
    window.addEventListener("beforeinstallprompt", handler);
    const t = setTimeout(() => setVisible(true), 2500);
    return () => { window.removeEventListener("beforeinstallprompt", handler); clearTimeout(t); };
  }, []);

  const install = async () => {
    if (prompt) { prompt.prompt(); await prompt.userChoice; }
    dismiss();
  };
  const dismiss = () => { setVisible(false); localStorage.setItem("aether_pwa_dismissed", "1"); };

  if (!visible) return null;
  return (
    <div data-testid="pwa-banner"
      className="w-full shrink-0 flex items-center gap-2.5 px-3 py-2 bg-surface border-b border-white/10">
      <div className="w-8 h-8 rounded-lg bg-brand flex items-center justify-center shrink-0">
        <Download className="w-4 h-4 text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold leading-tight truncate">Add AFTERHELLO to Home Screen</p>
      </div>
      <Button data-testid="pwa-install-button" onClick={install}
        className="h-8 px-3 rounded-full bg-brand hover:bg-brand-hover text-white text-xs transition-colors shrink-0">Install</Button>
      <button data-testid="pwa-dismiss-button" onClick={dismiss} className="text-muted-foreground hover:text-white p-1 shrink-0">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
